import { render, staticRenderFns } from "./ReminderDialog.vue?vue&type=template&id=6e73fa94&scoped=true&"
import script from "./ReminderDialog.vue?vue&type=script&lang=ts&"
export * from "./ReminderDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReminderDialog.vue?vue&type=style&index=0&id=6e73fa94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e73fa94",
  null
  
)

export default component.exports